import { getDefaultDrills } from "../drill";

const DefaultMode = {
  name: "default",
  drills: getDefaultDrills,
};

export default DefaultMode;
